<ngx-codemirror
        [(ngModel)]="content"
        (ngModelChange)="update($event)"
        [options]="{
    lineNumbers: true,
    theme: 'material',
    mode: {name: 'handlebars', base: 'gcode'}
  }"
></ngx-codemirror>
